import React from 'react';
import {Link} from 'react-router-dom';

export default function MainLanding(props){
    return(
        <div id="how-to" style={{textAlign: "center"}}>
            <div style={{marginTop: '1rem'}}>
                <Link to="/main/game-new"><input type="button" value="New Game" className="btnStretch btnColoring"/></Link>
                <br/>
                <Link to="/main/game-join"><input type="button" value="Join Game" className="btnStretch btnColoring"/></Link>
            </div>
            <section>
                <details className="menuWrapper">
                    <summary>The Details</summary>
                    <p>
                        Keep track of your disc golf matches played at Buhl Park! Select the "Games" option create
                        or join existing games. Once in a match simply update your tee score as you play & eveyone
                        else in the match will automatically update! Along with individual tee scores a match scorecard
                        for the match is available and also updates automatically! Once the match is completed simply
                        leave the room & the match will be added to your history!
                        <br/>
                        <br/>
                        Speaking of match history, to view past matches simply select "History" from the top menu & a list
                        displaying dates, names, & locations of past matches will be displayed. View the match scorecard by
                        selecting the match from the list. Selecting the match a 2nd time will hide the scorecard.
                        <br/>
                        <br/>
                        Also, players can update account info at any point in time. Simply select "Account" from the top
                        menu. From there users can update any of the needed fields. To update the account permanently be
                        sure to hit the "update" button at the bottom or changes will not be saved. Lastly, users can delete
                        their accounts at any point by clicking the "Delete Account" button <i>(But we hope you don't)</i>.
                        Deleting your account immediately logs the player out of the application.
                    </p>
                </details>
                <details className="menuWrapper">
                    <summary>Rules of Disc Golf</summary>
                    <ul style={{textAlign: "left"}}>
                        <li>General</li>
                        <ul>
                            <li>Similar to the rules of "Club Golf"</li>
                            <li>Each hole starts with a tee-off & is followed by subsequent throws till players reach the basket(hole)</li>
                            <li>Each throw or penalty counts as a 1 stroke. Strokes are totaled to arrive at the game score in which the fewest strokes win.</li>
                        </ul>
                        <li>Disc</li>
                        <ul>
                            <li>Throw Disc: Used in gameplay</li>
                            <li>Marker Disc: Used to mark where the Throw Disc landed</li>
                        </ul>
                        <li>Tee-off & Foot Placement</li>
                        <ul>
                            <li>At the 1st tee, the first to tee-off will be agreed upon by the group</li>
                            <li>For the remaining tee-offs the lowest score from the previous tee goes first</li>
                            <li>The "Plant Foot" which you place your weight on should be as close to the tee or marker disc as possible</li>
                            <li>In no instance should your "Plant Foot" be ahead of the mentioned markers & no more than a foot behind</li>
                            <li>The other foot can be located anywhere provided it's behind the mentioned markers.</li>
                        </ul>
                        <li>Follow-Through & Putts</li>
                        <ul>
                            <li>After the disc leaves the players hand the player can fall forward past the marker disc or tee</li>
                            <li>The exception to this rule is when putting. Any stoke occurring within 10 meters of a hole is considered a putt.</li>
                        </ul>
                        <li>Hazard, Boundary, Etc</li>
                        <ul>
                            <li>Trees: Place the marker under the disc caught in the tree and take your next turn from there. Add a 1 stroke penalty to your score</li>
                            <li>Out of Bounds: Place the marker where the disc crossed out of bounds and take your next turn from there. Add a 1 stroke penalty to your score</li>
                            <li>Water Hazards: Play is as you would an "Out of Bounds" action. Also, good like finding your disc!!!</li>
                        </ul>
                        <li>Mandatory Dog-leg</li>
                        <ul>
                            <li>Used to keep players out of areas or to make a course more difficult</li>
                            <li>Designated (normally) by a sign at the tee</li>
                            <li>Indicates the side which the disc must pass of an obstacle</li>
                            <li>If the disc passes on the wrong side if must be passed back on either side of the dog-leg</li>
                            <li>From there the player can then pass the dog-leg on the correct side & continue</li>
                        </ul>
                    </ul>
                </details>
            </section>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/comps/mainLanding.js